<template>
  <div
    class="max-w-5xl  w-full flex flex-col justify-center items-center py-4 px-2"
    id="witei"
  >


 <!-- paginado -->
    <div class="mb-4 py-2 w-full justify-end flex flex-row">
      <button @click="toPageFnc(previous)" :class="{
        'pointer-events-none bg-gray-500' : previous === null || loading,
        'bg-orange-500': previous !== null  && !loading
      }" class="mr-2 px-3 py-2 rounded-md text-white">Anterior</button>
      <button @click="toPageFnc(next)" 
      
      :class="{
        'pointer-events-none  bg-gray-500' : next === null || loading ,
        'bg-orange-500': next !== null && !loading}"
      class="px-3 py-2 rounded-md text-white">Siguiente</button>
    </div>

 
    <!-- loading -->
    <div v-if="loading" class="py-64 w-full spinner">
    </div>

    <!-- listado -->
    <div class="w-full" v-if="!loading">
    <transition-group name="list">
    <div     
      class="mb-8 border border-gray-400 rounded-md overflow-hidden shadow-md w-full flex flex-col sm:flex-row"            
      :key="item.id"
      v-for="(item, index) in list"
    >
      <div class="relative imagen">
        <vue-glide
          v-model="item.slideActive"
          :perView="1"
          :gap="0"
          :bound="true"
        >
          <vue-glide-slide          
            v-for="(picture, ind) in getPictures(item)"
            :key="index + '-' + ind"
          >
            <div
              class="imagen bg-no-repeat bg-cover bg-center"
              :style="`background-image: url(${picture})`"
            />
          </vue-glide-slide>
          <!-- Controls -->
          <template slot="control">
            <button style="top: 50%" class="flex items-center justify-center mx-2 rounded-full bg-opacity-75 bg-white absolute left-0 h-8 w-8" data-glide-dir="<">              
               <i class="text-gray-700 text-xl fas fa-caret-left"></i>
            </button>
            <button style="top: 50%;" class="flex items-center justify-center mx-2 rounded-full bg-opacity-75 bg-white absolute right-0 h-8 w-8" data-glide-dir=">">
              <i class="text-gray-700 text-xl fas fa-caret-right"></i>
            </button>
          </template>
        </vue-glide>

        <div
          class="p-1 w-full absolute bottom-0 justify-center flex flex-row text-white shadow-lg text-xl"
        >
          <div
            class="w-fit flex flex-wrap py-0 px-2 items-center justify-center rounded-full bg-black bg-opacity-50"
          >
            <button
              v-for="(picture, ind) in item.pictures"
              :key="ind"
              style="width:5px; height: 5px"
              class="bg-gray-400 focus:bg-orange-700 rounded-full my-1 mr-1 ml-px"
              :class="{ 'bg-orange-700': ind === item.slideActive }"
              @click="item.slideActive = ind"
            ></button>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col justify-between p-3 w-full text-base text-gray-900 "
      >
        <div class="pb-3">
          <div
            class="capitalize1 text-md font-semibold"
            v-if="item.title !== ''"
          >
            {{ item.title }}
          </div>
          <span v-if="item.street !== ''">{{ item.street }},&nbsp;</span
          >{{ item.zip_code }},&nbsp;
          {{ item.province }}
        </div>
        <div class="flex flex-wrap text-sm text-black font-light">
          <div v-if="item.bedrooms > 0">
            {{ item.bedrooms | plural("Hab") }}
            <span class="p-2">-</span>
          </div>
          <div v-if="item.area > 0">
            {{ item.area }}m²
            <span class="p-2">-</span>
          </div>
        </div>
        <div class="mt-2 flex flex-wrap text-sm font-bold text-green-900">
          <div>
            <span class=" capitalize" v-if="item.kind !== ''">{{
              item.kind
            }}</span>
            <span v-if="item.floor_display"
              >&nbsp;{{ item.floor_display }}</span
            >
            <span v-if="item.town !== ''"> -
            {{ item.town }}</span>
          </div>
        </div>

        <div
          class="w-full sm:w-2/3 my-2 flex flex-wrap text-sm font-light italic text-gray-900"
        >
          <div
            class="mb-2 mr-2 px-3 py-1 bg-green-200 rounded-full whitespace-no-wrap truncate"
            :key="ind"
            v-for="(tag, ind) in item.tags"
          >
            {{ tag }}
          </div>
        </div>
        <div class="h-full"></div>
        <div class="w-full flex flex-row justify-between">
          <div v-if="item.renting_cost !== 0" class=" text-lg font-bold">
            {{ item.renting_cost }} € /{{ item.renting_period_display }}
          </div>

          <div class="self-end text-xs font-light text-gray-600">
            Última actualización: {{ item.updated | last_update }}
          </div>
        </div>
      </div>
    </div>
    </transition-group>
    </div>
    

    <!-- paginado -->
    <div v-if="!loading" class="mb-4 py-2 w-full justify-end flex flex-row">
      <button @click="toPageFnc(previous)" :class="{
        'pointer-events-none bg-gray-500' : previous === null || loading,
        'bg-orange-500': previous !== null  && !loading
      }" class="mr-2 px-3 py-2 rounded-md text-white">Anterior</button>
      <button @click="toPageFnc(next)" 
      
      :class="{
        'pointer-events-none  bg-gray-500' : next === null || loading ,
        'bg-orange-500': next !== null && !loading}"
      class="px-3 py-2 rounded-md text-white">Siguiente</button>
    </div>

  </div>
</template> 

<script>
// import Carousel from "./Carousel";

var url1 = "./test.json"; //
url1 = "https://rentame.es/wp-content/plugins/witei/server.php";

import { Glide, GlideSlide } from "vue-glide-js";
import "vue-glide-js/dist/vue-glide.css";  

export default {
  components: {
    VueGlide: Glide,
    VueGlideSlide: GlideSlide,  
  },
  name: "Listado",
  props: {
    sortType: {
      type: Object,
      default : () => { return {} }
    }
  },
  filters: {
    plural: function(value, text) {
      let s = value + " " + text;
      if (Number(value) > 1) {
        s = s + "s";
      }
      return s;
    },
    renting_period: function(value) {
      if (value === "monthly") return "€/mes";

      return value;
    },
    last_update: function(value) {
      var d1 = new Date();
      var d2 = new Date(value);
      var s = value;
      var dif = d1 - d2;
      dif = dif / (24 * 3600 * 1000);
      if (dif >= 1) {
        s = Math.ceil(dif);
        if (s === 1) s = s + " día";
        if (s > 1) s = s + " días";
      }
      if (dif < 1) {
        var h = Math.floor(dif * 24);
        s = h + " Horas";
      }

      return s;
    }
  },
  data: function() {
    return {
      loading: true,
      params: `?buyop=rent&sort_by=${this.sortType.type}&`,
      list: [],
      next: null,
      previous: null,
      carouselOptions: {
        name: "gallery",
        width: 200,
        step: 2,
        margin: "auto",
        arrow: "float"
      }
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    getImage(pic) {
      console.log(pic)
      if (pic !== undefined) {        
      return require('@/assets/' + pic)
      } else {
        return '';
      }

    },
    getPictures(item) {
      let pics = item.pictures
      if (pics.length === 0) {
        pics = [this.getImage('img/logoblanco.png')]
      } 

      return pics;
    },
    toPageFnc(params) {
      this.params = params;
      this.fetchData();
    },
    cleanPage(page) {
      let pageTo = null;
      if (page !== null) {
      pageTo = page.split('http://witei.com/api/v1/houses/').join('')
      }

      return pageTo;
    },
    recargar(type,min,max,armin,armax) {
 

      let moreparam = [];
      if (min !== -1) {
        moreparam.push(`min_price=${min}`)
      }
      if (max !== -2) {
        moreparam.push(`max_price=${max}`)
      }
      if (armin !== -1) {
        moreparam.push(`area_min=${armin}`)
      }
      if (armax !== -2) {
        moreparam.push(`area_max=${armax}`)
      }
      
      const moreparams = moreparam.join('&')
      this.params = `?buyop=rent&sort_by=${type}&${moreparams}`,
      console.log(this.params);
      this.fetchData()
    },
    fetchData() {
      this.loading = true;
      window.scrollTo({ top: 0, behavior: 'smooth' })
      fetch(url1 + this.params, {
        method: "GET",
        mode: "cors"
      })
        .then(function(response) {
          return response.json();
        })
        .then(data => {
          setTimeout( () => {
            this.loading = false;
          }, 500);

          this.next = this.cleanPage(data.next)
          this.previous = this.cleanPage(data.previous);

          const list = data.results;
          const n = list.length;
          for (let i = 0; i < n; i++) {
            list[i].slideActive = 0;
          }

          this.list = list;
          
        });
    }
  }
};
</script>
<style lang="postcss" scoped>
.imagen {
  width: 100%;
  height: 300px;
}

@media (min-width: 640px) {
  .imagen {
    width: 300px;
    height: 300px;
  }
}

@media (min-width: 768px) {
  .imagen {
    width: 400px;
    height: 400px;
  }
}

*,
*:focus,
*:hover {
  outline: none !important;
} 

.boton {
  @apply bg-gray-500 rounded-md border z-50;
}

.list-enter-active {
  @apply transition-all ease-in duration-500;
}

.list-leave-active {
  @apply transition-all ease-in duration-500;
}

.list-enter,
.list-leave-to {
  @apply opacity-0 transform translate-y-2;
}

 
.marcar {
  background-color: tomato;
  display: block;
}
</style>